import { IconProps } from '@tabler/icons-react-native'
import { Path, Svg } from 'react-native-svg'

export default function Arrow({
  size = 24,
  strokeWidth = 2,
  color = 'black',
  ...props
}: IconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M12 5V19M6 13L12 19L18 13"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
